import React, { useState, useEffect } from "react"

// components
import { PrimeButton, TextInput } from "components-design-system"
import { useShallow } from "zustand/react/shallow"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"
import useAuthoringDataStore from "../../../hooks/stores/useAuthoringDataStore"

const RJTextArea = (props) => {
  let { id, carbonProps, invalid, value, onChange, onFocus, onBlur, uiSchema } = props

  const [formValue, setFormValue] = useState("")

  const { formData, setFormData } = useAuthoringDataStore(
    useShallow((state) => ({
      formData: state.formData,
      setFormData: state.setFormData,
    }))
  )

  useEffect(() => {
    if (value) setFormValue(value)
  }, [])

  const copyValues = () => {
    let study_data = {
      ...formData,
    }
    let values = []
    let value = ""
    let copyLogic = uiSchema["ui:options"]?.copyLogic

    if (copyLogic === "secondaryIdsEupas") {
      if (study_data?.protocol?.study_identification?.secondary_ids) {
        study_data.protocol.study_identification.secondary_ids.forEach((item) => {
          if (item && item.id && item.id.length > 0) {
            let value = item.id
            if (item?.secondary_id_type) value = `${item.id} (${item.secondary_id_type})`
            values.push(value)
          }
        })
      }

      value = values.join(", ")
      study_data.protocol.study_identification.other_study_identification_numbers = value
    }

    setFormData(study_data)
    setFormValue(value)
  }

  const handleChange = (e) => {
    setFormValue(e)
    onChange(e)
  }

  let variant

  if (invalid) {
    variant = "error"
  }

  let copyButtonTitle = ""

  if (uiSchema["ui:options"].copyButtonTitle) {
    copyButtonTitle = uiSchema["ui:options"].copyButtonTitle
  }

  return (
    <>
      <TextInput
        id={`${id}-field`}
        className="rjs-widget"
        style={carbonProps?.styles && carbonProps.styles.widget}
        type="textarea"
        disabled={carbonProps.disabled}
        value={formValue}
        onChange={(e) => handleChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <PrimeButton
        type="dashed"
        size="small"
        style={{ marginTop: 12 }}
        onClick={() => copyValues()}
      >
        {copyButtonTitle}
      </PrimeButton>
      {/* {invalid && <Note type="error" text={invalidText} style={{ marginTop: 4 }} />} */}
    </>
  )
}

export default InputWrapper(RJTextArea)
